import { Component, OnInit, ViewChild, ElementRef, AfterViewChecked, NgZone, LOCALE_ID, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { environment } from '../environments/environment';
import { BackendService } from './services/backend.service';
import { MatDialog } from '@angular/material';
import { RecaptchaTokenService } from './services/recaptcha-token.service';
import { GenericErrorDialogComponent } from './dialogs/generic-error-dialog/generic-error-dialog';
import { RequestSentDialogComponent } from './dialogs/request-sent-dialog/request-sent-dialog';
import { IncorrectCaptchaDialogComponent } from './dialogs/incorrect-captcha-dialog/incorrect-captcha-dialog';
import { ProductNotFoundDialogComponent } from './dialogs/product-not-found-dialog/product-not-found-dialog';
import { InvalidInputDialogComponent } from './dialogs/invalid-input-dialog/invalid-input-dialog';
import { SalesRequestOkDialogComponent } from './dialogs/sales-request-ok-dialog/sales-request-ok-dialog';
import { WrongLanguageDialogComponent } from './dialogs/wrong-language-dialog/wrong-language-dialog';
import { RoburCertificationRequestResult, ContactSalesRequest, ContactSalesRequestResult, RoburCertificationRequest } from './models';

import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewChecked  {

    @ViewChild('contentContainer') contentContainerRef: ElementRef;

    public mainForm: FormGroup;
    public isLoading = false;
    public isProduction = environment.production;
    private currentCounter: number;

    public usaTema: string = "";
    private lastSentHeight: number = 0; // Memorizza l'ultima altezza inviata
    onScriptLoad() {
        console.log('Google reCAPTCHA loaded and is ready for use!');
    }

    onScriptError() {
        console.log('Something went long when loading the Google reCAPTCHA');
    }

    clearForm(): any {
        window.location.reload();
    }

    constructor(
        private backendService: BackendService,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private recaptchaTokenService: RecaptchaTokenService,
        private route: ActivatedRoute,
        private elementRef: ElementRef,
        private ngZone: NgZone,
        @Inject(LOCALE_ID) public locale: string) {

    }

    ngOnInit() {
        this.createForm();
        this.route.queryParams.subscribe(params =>  {
            this.usaTema = params['theme'] || "";
        });
    }
    ngAfterViewChecked() {
        if (this.contentContainerRef) {
            const currentHeight = this.contentContainerRef.nativeElement.offsetHeight;
        
            // Controllo per inviare il messaggio solo se l'altezza è cambiata
            if (currentHeight > 0 && currentHeight !== this.lastSentHeight) {
                // Usa NgZone.run() per uscire dalla change detection e inviare
                // Il postMessage non deve innescare un nuovo ciclo di CD.
                this.ngZone.runOutsideAngular(() => {
                    window.parent.postMessage({ 'frameHeight': (currentHeight/* + 120/*aggiungo il padding:60 */) }, '*');
                });
                this.lastSentHeight = currentHeight;
            }
        }
    }

    createForm() {

        this.mainForm = this.fb.group({
            name: ['', [
                Validators.required,
            ]],
            surname: ['', [
                Validators.required,
            ]],
            company: [''],
            email: ['', [
                Validators.required,
                EmailValidator
            ]],
            phone: ['', [
                Validators.required,
            ]],
            batchCode: ['', [
                Validators.required,
            ]],
            productCode: ['', [
                Validators.required,
                Validators.minLength(9),
                Validators.maxLength(9)
            ]],
            language: ['', [
                Validators.required
            ]],
            canContact: ['', [
                Validators.requiredTrue
            ]]/*,
            recaptcha: [false, [
                Validators.requiredTrue
            ]]*/
        });

    }

    contactSales() {

        this.isLoading = true;

        const obj: ContactSalesRequest = {
            'name': this.mainForm.get('name').value,
            'surname': this.mainForm.get('surname').value,
            'phone': this.mainForm.get('phone').value,
            'company': this.mainForm.get('company').value,
            'email': this.mainForm.get('email').value,
            'productCode': this.mainForm.get('productCode').value,
            'batchCode': this.mainForm.get('batchCode').value,
        };

        this.backendService.contactSales(obj).subscribe(res => {

            switch (res) {
                case ContactSalesRequestResult.GenericError:

                    this.dialog.open(GenericErrorDialogComponent, {
                        width: '300px'
                    });

                    break;

                case ContactSalesRequestResult.InvalidInput:

                    this.dialog.open(InvalidInputDialogComponent, {
                        width: '300px'
                    });


                    break;

                case ContactSalesRequestResult.Ok:

                    this.dialog.open(SalesRequestOkDialogComponent, {
                        width: '300px'
                    });

                    break;

            }

            this.isLoading = false;

        }, err => {
            console.log(err);
            this.isLoading = false;

            this.dialog.open(GenericErrorDialogComponent, {
                width: '300px'
            });

        });

    }

    onSubmit() {


        // Disattivato per richiesta di Gianluca Innamorato
        // by Luca Di Leo @ 09/05/2018
        /*const challenge = this.recaptchaTokenService.getRecaptchaToken();*/

        this.isLoading = true;

        const obj: RoburCertificationRequest = {
            'name': this.mainForm.get('name').value,
            'surname': this.mainForm.get('surname').value,
            'phone': this.mainForm.get('phone').value,
            'company': this.mainForm.get('company').value,
            'email': this.mainForm.get('email').value,
            'productCode': this.mainForm.get('productCode').value,
            'batchCode': this.mainForm.get('batchCode').value,
            /*'captcha': challenge,*/
            'language': this.locale,
            'certificateLanguage': this.mainForm.get('language').value
        };

        this.backendService.requestRoburCertificate(obj).subscribe(res => {

            this.isLoading = false;

            switch (res) {

                case RoburCertificationRequestResult.ResultOk:

                    this.dialog.open(RequestSentDialogComponent, {
                        width: '300px'
                    }).afterClosed().subscribe(r => {
                        this.clearForm();
                    });

                    break;

                case RoburCertificationRequestResult.ResultInvalidInput:

                    this.dialog.open(InvalidInputDialogComponent, {
                        width: '300px'
                    });

                    break;


                case RoburCertificationRequestResult.ResultInvalidCaptcha:

                    this.dialog.open(IncorrectCaptchaDialogComponent, {
                        width: '300px'
                    });

                    break;

                case RoburCertificationRequestResult.ResultOkWrongLanguage:

                    this.dialog.open(WrongLanguageDialogComponent, {
                        width: '300px'
                    }).afterClosed().subscribe(r => {
                        this.clearForm();
                    });

                    break;

                case RoburCertificationRequestResult.ResultNotFound:

                    this.dialog.open(ProductNotFoundDialogComponent, {
                        width: '500px'
                    }).afterClosed().subscribe(r => {
                        if (r) { this.contactSales(); }
                    });

                    break;

                case RoburCertificationRequestResult.ResultInvalidInput:

                    this.dialog.open(IncorrectCaptchaDialogComponent, {
                        width: '300px'
                    });

                    break;
                default:

                    this.dialog.open(GenericErrorDialogComponent, {
                        width: '300px'
                    });

            }

        }, err => {

            console.log(err);
            this.isLoading = false;

            this.dialog.open(GenericErrorDialogComponent, {
                width: '300px'
            });
        });
    }

    testData() {
        this.mainForm.patchValue({
            name: 'Pippo',
            surname: 'Plutone',
            company: 'Casamia',
            email: 'test@test.it',
            phone: '37676754434',
            productCode: '123456543',
            batchCode: '2345654',
            language: 'IT',
            canContact: true
        });

    }


}

export function EmailValidator(control: AbstractControl) {

    // tslint:disable-next-line:max-line-length
    if (/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/.test(control.value)) {
        return null;
    }
    return { email: true };
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts